// ExtendedDirectSelect mode
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import CommonSelect from './CommonSelect.jsx';
import _ from 'lodash';

const ExtendedDirectSelect = _.extend({}, MapboxDraw.modes.direct_select);

ExtendedDirectSelect.startDragging = function (state, e) {
    MapboxDraw.modes.direct_select.startDragging.call(this, state, e);
    CommonSelect.startOnActiveFeature.call(this, state, e);
};

ExtendedDirectSelect.onDrag = function (state, e) {
    if (state.extrudingTargetId) {
        return CommonSelect.dragMove.call(this, state, e);
    }

    MapboxDraw.modes.direct_select.onDrag.call(this, state, e);
    this.map.fire('draw.editing', {
        features: [state.feature.toGeoJSON()]
    });
};

ExtendedDirectSelect.onVertex = function (state, e) {
    // ignore drag if the alt key is down (user intends to extrude)
    if (!CommonSelect.isAltDown(e)) {
        if (state.feature.properties.radius) {
            return this.changeMode('draw_circle', {
                edit: state.featureId,
                lngLat: e.lngLat
            });
        }
        MapboxDraw.modes.direct_select.onVertex.call(this, state, e);
    }
};

ExtendedDirectSelect.onMidpoint = function (state, e) {
    // ignore drag if the alt key is down (user intends to extrude)
    if (!CommonSelect.isAltDown(e)) {
        if (state.feature.properties.radius) {
            return this.changeMode('draw_circle', {
                edit: state.featureId,
                lngLat: e.lngLat
            });
        }
        MapboxDraw.modes.direct_select.onMidpoint.call(this, state, e);
    }
};

ExtendedDirectSelect.onTrash = function (state) {
    // delete entire feature if no points are selected, or if it's a radius object
    if (state.selectedCoordPaths.length === 0 || state.feature.properties.radius) {
        this.deleteFeature([state.featureId]);
        this.changeMode('simple_select', {});
        return;
    }

    MapboxDraw.modes.direct_select.onTrash.call(this, state);
};

ExtendedDirectSelect.toDisplayFeatures = function (state, geojson, display) {
    MapboxDraw.modes.direct_select.toDisplayFeatures.call(this, state, geojson, display);

    // This is an attempt to not display midpoints in radius mode; would need to define 'createSupplementaryPoints'
    // to complete this; however, abandoning as it makes it harder to know when the circle is in 'direct_select'
    // mode and that the points can be dragged to adjust the radius
    // based on direct_select.toDisplayFeatures, but with an extra check for radius mode polygons
    // if (state.featureId === geojson.properties.id) {
    //     geojson.properties.active = 'active';
    //     display(geojson);
    //     createSupplementaryPoints(geojson, {
    //         map: this.map,
    //         midpoints: !geojson.properties.radius,
    //         selectedPaths: state.selectedCoordPaths
    //     }).forEach(display);
    // } else {
    //     geojson.properties.active = 'inactive';
    //     display(geojson);
    // }
    // this.fireActionable(state);

    CommonSelect.toDisplayFeatures.call(this, state, geojson, display);
};

export default ExtendedDirectSelect;
